import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {SOConsolidationRunModel} from "../../../../../../models/aggregates/so-consolidation/index";
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from "../../shared";
import {Observable} from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class SOConsolidationRunService extends BaseApiTemplateService<SOConsolidationRunModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-hdrs/backoffice-ep";
    this.httpClient = http;
  }

  createWthProcessor(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        "sales-order-to-sales-invoice-consolidation/run-hdrs/processors/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
